import './polyfills';

if (process.env.NODE_ENV === 'development') {
  // Must use require here as import statements are only allowed
  // to exist at top-level.
  require('preact/debug');
}
import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import './global.css';
import './include/bootstrap';
import store from './store';
import AppRoutesWrapper from './routes';

const target = document.querySelector('#root');
target.style.height = '100%';

const root = createRoot(target);
root.render(
  <Provider store={store}>
    <AppRoutesWrapper />
  </Provider>
);
